// extracted by mini-css-extract-plugin
export default {"wrapper":"TrackerChartIcon_wrapper__sxCj5"};